module.exports = __webpack_public_path__ + "img/kr-product-agency-card2-img2.317a8ea.png";